import { changeColorScheme } from "./colorScheme";
import { GrenadeObject } from "./grenadeObject";
import { type Coord } from "./types";
import { setMousePositionFromCoord, waitForAnimationEnd } from "./utils";

export class FlashbangObject extends GrenadeObject {
  static override readonly IMAGE_SRC = "/assets/flashbang.png";

  override async detonateAt(coord: Coord) {
    const flashOverlay = document.createElement("div");
    flashOverlay.className = "flash-overlay";
    document.body.appendChild(flashOverlay);

    const flashNegativeFlash = document.createElement("div");
    flashNegativeFlash.className = "flash-negative-flash";
    setMousePositionFromCoord(flashNegativeFlash, coord);
    flashOverlay.appendChild(flashNegativeFlash);

    changeColorScheme("light");

    await new Promise((resolve) => setTimeout(resolve, 1000 / 30)); // Negative flash for a few frames only

    flashNegativeFlash.remove();

    await waitForAnimationEnd(flashOverlay);

    flashOverlay.remove();
  }
}
